






















import { Component, Mixins, Vue } from "vue-property-decorator";
import { Action, State } from "vuex-class";

import AppContent from "@/components/AppContent/AppContent.vue";
import AppHeader from "@/components/AppHeader/AppHeader.vue";
import AppHeaderMain from "@/components/AppHeader/AppHeaderMain.vue";
import TeachersTable from "@/components/TeachersTable/TeachersTable.vue";
import TableToolbar from "@/components/TableToolbar/TableToolbar.vue";
import StickyListHeader from "@/components/StickyListHeader/StickyListHeader.vue";

import BaseSpinner from "@/components/BaseSpinner/BaseSpinner.vue";
import BaseAlert from "@/components/BaseAlert/BaseAlert.vue";

import EventBus from "@/utils/helpers/EventBus";
import RequestState from "@/utils/mixins/RequestState";

import { ITeacher } from "@/models/interfaces/teachers";

@Component({
  components: {
    AppContent,
    AppHeader,
    AppHeaderMain,
    TeachersTable,
    TableToolbar,
    StickyListHeader,

    BaseSpinner,
    BaseAlert
  }
})
export default class TeachersView extends Mixins(RequestState) {
  @State("teachers", { namespace: "teachers" })
  private teachers!: ITeacher;

  @Action("teachers/fetchTeachers")
  private fetchTeachers!: () => Promise<ITeacher[]>;

  public mounted() {
    this.fetchTeachers();
  }
}
